<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Sektör Tipi</label>
            <input type="text" class="form-control"  placeholder="Sektör Tipi" v-model="value.Name"/>
        </div>
        
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
    },
    data(){
        
    }
}
</script>


<style lang="scss">
</style>